import { Injectable, signal } from '@angular/core';
import { mergeMap, Observable, Subject, tap } from 'rxjs';
import { TaskStatusService } from '../../../on-premise-sync-progress-dialog/task-status.service';
import { SubjectOnPremiseSyncService } from './subject-on-premise-sync.service';
import { InspectionTemplateOnPremiseSyncService } from "./inspection-template-on-premise-sync.service";
import { InspectionFirstSyncService } from "./inspection-first-sync.service";
import { InspectionImageFirstSyncService } from "./inspection-image-first-sync.service";
import { ReportTemplateSyncService } from "./report-template-sync.service";
import { InspectionReportSyncService } from "./inspection-report-sync.service";
import { ModifiedImagesFirstSyncService } from './modified-images-first-sync.service';

@Injectable({
  providedIn: 'root'
})
export class OnPremiseFirstSyncService {
  private onPremiseFirstSyncSubject = new Subject();
  public onPremiseFirstSyncCompleted$ = this.onPremiseFirstSyncSubject.asObservable();

  constructor(
    private inspectionTemplateSyncService: InspectionTemplateOnPremiseSyncService,
    private subjectSyncService: SubjectOnPremiseSyncService,
    private taskStatusService: TaskStatusService,
    private inspectionSyncService: InspectionFirstSyncService,
    private inspectionImageSyncService: InspectionImageFirstSyncService,
    private modifiedImagesFirstSyncService: ModifiedImagesFirstSyncService,
    private inspectionReportSyncService: InspectionReportSyncService,
    private inspectionReportTemplateSyncService: ReportTemplateSyncService,
  ) { }

  public syncOfflineData(): Observable<unknown> {
    this.initSyncProgressTasks();

    return this.inspectionTemplateSyncService.createInspectionTemplates()
      .pipe(
        tap(() => this.taskStatusService.updateTaskStatus('onPremiseSyncDialog.tasks.createInspectionTemplates', true)),
        mergeMap(() => this.subjectSyncService.createSubjects()),
        tap(() => this.taskStatusService.updateTaskStatus('onPremiseSyncDialog.tasks.createSubjects', true)),
        mergeMap(() => this.inspectionSyncService.createInspections()),
        tap(() => this.taskStatusService.updateTaskStatus('onPremiseSyncDialog.tasks.createInspections', true)),
        mergeMap(() => this.inspectionImageSyncService.createInspectionImages()),
        tap(() => this.taskStatusService.updateTaskStatus('onPremiseSyncDialog.tasks.createInspectionImages', true)),
        mergeMap(() => this.modifiedImagesFirstSyncService.syncModifiedImages()),
        tap(() => this.taskStatusService.updateTaskStatus('onPremiseSyncDialog.tasks.createModifiedImages', true)),
        mergeMap(() => this.inspectionReportTemplateSyncService.createReportTemplates()),
        tap(() => this.taskStatusService.updateTaskStatus('onPremiseSyncDialog.tasks.createReportTemplates', true)),
        mergeMap(() => this.inspectionReportSyncService.createReports()),
        tap(() => this.taskStatusService.updateTaskStatus('onPremiseSyncDialog.tasks.createReports', true)),
        mergeMap(() => this.inspectionSyncService.deleteInspections()),
        tap(() => this.onPremiseFirstSyncSubject.next({}))
      );
  }

  private initSyncProgressTasks() {
    this.taskStatusService.initTasks([
      { name: 'onPremiseSyncDialog.tasks.createInspectionTemplates', isCompleted: false },
      { name: 'onPremiseSyncDialog.tasks.createSubjects', isCompleted: false },
      { name: 'onPremiseSyncDialog.tasks.createInspections', isCompleted: false },
      { name: 'onPremiseSyncDialog.tasks.createInspectionImages', isCompleted: false },
      { name: 'onPremiseSyncDialog.tasks.createModifiedImages', isCompleted: false },
      { name: 'onPremiseSyncDialog.tasks.createReports', isCompleted: false },
      { name: 'onPremiseSyncDialog.tasks.createReportTemplates', isCompleted: false },
    ]);
  }
}
